import styled from 'styled-components'

export const StatsLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: var(--text-11);
`

export const StatsPanel = styled.div`
  border-radius: 10px;
  background: var(--appearanceA-7);
  padding-inline: 10px;
  padding-block: 8px;
`
